import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { push } from "store/actions/router";
import { Card } from "react-bootstrap";
import IconHeader from "components/IconHeader";
import IconSubheader from "components/IconSubheader";
import { FiAlertTriangle } from "react-icons/fi";
import IconCircle from "components/IconCircle";
import type { RootState } from "types/state";

import Button from "components/Button";

interface IconAuthlessErrorStateOwnProps {
  header?: string;
  subheader?: string;
  onClick?: () => void;
  isFetching?: boolean;
  actionText?: string;
}

const mapStateToProps = (state: RootState) => {
  return {
    referralPlans: state.employer.referralPlans,
  };
};

const mapDispatchToProps = {
  push,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type IconAuthlessErrorStateProps = PropsFromRedux &
  IconAuthlessErrorStateOwnProps;

class IconAuthlessErrorState extends React.PureComponent<
  WithApolloClient<IconAuthlessErrorStateProps>
> {
  _login = () => {};

  render() {
    return (
      <>
        <Card>
          <div
            style={{
              textAlign: "center",
            }}
          >
            <div
              style={{
                paddingTop: 20,
                paddingBottom: 20,
              }}
            >
              <IconCircle
                type="error"
                icon={
                  <FiAlertTriangle color="white" stroke="#B12121" size={16} />
                }
              />
            </div>
            <div>
              <IconHeader
                variant="referralHeader"
                headerText={this.props.header}
                style={{
                  color: "#B12121",
                }}
              />
              <IconSubheader subheader={this.props.subheader} />
            </div>
            <section
              style={{
                paddingTop: 10,
                paddingBottom: 20,
              }}
            >
              {this.props.onClick && (
                <div className="step-btn">
                  <Button
                    size="sm"
                    color="action"
                    name="action"
                    onClick={this.props.onClick}
                    loading={this.props.isFetching}
                  >
                    {this.props.actionText}
                  </Button>
                </div>
              )}
            </section>
          </div>
        </Card>
      </>
    );
  }
}

export default connector(
  withApollo<IconAuthlessErrorStateProps>(IconAuthlessErrorState)
);
